import { useEffect, useState } from "react";

/**
 *
 * @param {import("react-router-dom").Location} location
 */
export const useQueryParams = location => {
  const getLocationParams = location =>
    location.search
      ? location.search
      : location.hash.split("?")?.[location.hash.split("?").length - 1];
  const [urlParams, setURLParams] = useState(
    getLocationParams(location || window.location)
  );
  useEffect(() => {
    setURLParams(getLocationParams(location || window.location));
  }, [location, window.location]);

  const searchParams = new URLSearchParams(urlParams);
  /** @type {{ [key: string]: string | string[] }} */
  const entries = {};
  for (let key of Array.from(searchParams.keys())) {
    entries[key] = searchParams.getAll(key);
    if (Array.isArray(entries[key]) && entries[key].length <= 1) {
      entries[key] = entries[key][0];
    }
  }
  return entries;
};
